import t from "./generateUtilityClasses.mjs";
import e from "./generateUtilityClass.mjs";
function a(i) {
  return e("MuiDivider", i);
}
const r = t("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), d = r;
export {
  d as default,
  a as getDividerUtilityClass
};
//# sourceMappingURL=dividerClasses.mjs.map
